<template>
	<div>
		<div
			v-if="loading"
			class="fill-height d-flex justify-center align-center"
			:style="{ height: `${$vuetify.breakpoint.height - 100}px` }"
		>
			<v-progress-circular
				color="primary"
				size="46"
				indeterminate
			/>
		</div>
		<div v-else-if="contents.length">
			<v-card
				flat
				:height="$vuetify.breakpoint.height - 80"
				class="mb-n6"
			>
				<bee-live-preview
					ref="livePreview"
					:questions="contents"
					barcode-text="12345678901234567890123456789012"
					show-print
					show-page-data
				/>
			</v-card>
		</div>
		<p
			v-else
			class="d-flex justify-center align-center text-center text-body-1 font-weight-bold"
			:style="{ height: `${$vuetify.breakpoint.height - 120}px` }"
		>
			لا يوجد أسئلة في هذا الاختبار، يرجى إضافة الأسئلة أولاً
		</p>
		
		<!-- back -->
		<div class="text-end">
			<v-btn
				depressed
				color="primary"
				height="34"
				class="ms-auto"
				@click="$router.go(-1)"
			>
				عودة
			</v-btn>
		</div>
	</div>
</template>

<script>
import { refactorQuestions } from '@/helpers/functions';
import BeeLivePreview from '@/components/BeeLivePreview.vue';

export default {
	name: 'ExamPreview',
	
	components: { BeeLivePreview },

	data() {
		return {
			loading: false,
			contents: [],
			mainData: {
				name: null,
				conceptId: null,
				classId: null,
				courseId: null,
				maxMark: null,
				subjectsIds: [],
				examsIds: [],
			},
		}
	},

	methods: {
		fetchTest() {
			this.loading = true;
			return Promise.all([
				this.$store.dispatch('exams/fetchById', {
					id: this.$route.params.examId
				}).then((data) => {
					this.mainData.examName = data.name;
					this.mainData.conceptId = data.concept?.id;
					this.mainData.classId = data.courseBrief?.specialty?.id;
					this.mainData.courseId = data.courseBrief?.id;
					this.mainData.maxMark = data.maxGrade;
					this.mainData.subjectsIds =
						data.topics.map(c => c.parent.id).filter((c, i, arr) => arr.indexOf(c) === i);
					this.mainData.examsIds = data.topics.map(c => c.id);
				}),
				this.$store.dispatch('exams/fetchQuestions', {
					id: this.$route.params.examId,
				}).then(data => {
					this.contents = refactorQuestions(
						data.map(c => ({ degree: c.degree, ...c.questionBankBriefResponse })),
						true
					);
				})
			]).then(() => {
				this.loading = false;

				if (this.$route.query.isPrint) {
					this.$nextTick(() => {
						setTimeout(this.$refs.livePreview.printPreview, 500);
					})
				}
			}).catch((e) => { 
				console.error(e);
				this.loading = false;
			});
		},
	},

	created() {
		this.fetchTest();
	}
}
</script>

<style>

</style>